import PropTypes from 'prop-types';
// @mui
import { List, Box } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
//
import { ListSubheaderStyle } from './style';
import NavList from './NavList';
import usePermissions from '../../../hooks/usePermissions';

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse, ...other }) {
  return (
    <Box {...other}>
      {navConfig.map((group) => (
        <Section key={group.subheader} group={group} isCollapse={isCollapse} />
      ))}
    </Box>
  );
}

const Section = ({ group, isCollapse }) => {
  const { translate } = useLocales();

  const { canView } = usePermissions();
  const filteredGroup = group.items.filter((item) => canView(item.permissionName || item.title));

  if (!filteredGroup.length) return null;

  return (
    <List key={group.subheader} disablePadding sx={{ px: 2 }}>
      <ListSubheaderStyle
        sx={{
          ...(isCollapse && {
            opacity: 0,
          }),
        }}
      >
        {translate(group.subheader)}
      </ListSubheaderStyle>

      {filteredGroup.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={1}
          disabled={list.disabled}
          hasChildren={!!list.children}
          isCollapse={isCollapse}
        />
      ))}
    </List>
  );
};
